import { Badge, BadgeType } from "../../../../components/badge/badge";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import "./locale-container.scss";

interface ILocaleContainerProps {
    localeCode: string;
    localeName: string;
    isNewLocale: boolean;
}

/**
 * Language row label: locale code badge + language name (+ optional New badge).
 * Replaces country flag icons so every locale has a stable code label
 * that matches the translations CSV column (e.g. en → EN, he → HE).
 */
const LocaleContainer: React.FC<ILocaleContainerProps> = ({
    localeCode,
    localeName,
    isNewLocale,
}): JSX.Element => {
    const codeLabel = localeCode.toUpperCase();

    return (
        <div className="locale-container">
            <span className="locale-code-label" title={codeLabel}>
                {codeLabel}
            </span>
            <FontBody2 variant={FONT_VARIANT.BOLD}>
                {localeName}
            </FontBody2>
            {isNewLocale &&
                <Badge text="New" type={BadgeType.PRIMARY} />
            }
        </div>
    );
};

export default LocaleContainer;
